interface IVideoAnalyzer {
  debug: boolean
  file: File | null
  fileFullName: string,
  fileName: string,
  fileSuffix: string,
  video: HTMLVideoElement | null
  // s
  duration: number
  // byte
  size: number
  width: number,
  height: number,
  type: string
  prepare: (
    file: File,
    onConfirm?: () => void,
    externalVideoEl?: HTMLVideoElement,
  ) => Promise<IVideoAnalyzer>
}

const videoAnalyzer: IVideoAnalyzer = {
  debug: false,
  file: null,
  fileFullName: '',
  fileName: '',
  fileSuffix: '',
  video: null,
  duration: 0,
  size: 0,
  width: 0,
  height: 0,
  type: '',
  prepare: (file: File, onConfirm?: () => void, externalVideoEl?: HTMLVideoElement) => {
    return new Promise((resolve, reject) => {
      const videoEl = externalVideoEl ? externalVideoEl : document.createElement('video') as HTMLVideoElement
      let timer: any = 0

      videoAnalyzer.file = file
      videoAnalyzer.fileFullName = file.name
      videoAnalyzer.fileName = file.name.slice(0, file.name.lastIndexOf('.'))
      videoAnalyzer.fileSuffix = file.name.slice(file.name.lastIndexOf('.') + 1, file.name.length)
      videoAnalyzer.size = file.size
      videoAnalyzer.type = file.type
      videoAnalyzer.video = videoEl

      if (!externalVideoEl) {
        videoEl.style.display = 'none'
        videoEl.muted = true
        videoEl.setAttribute('webkit-playsinline', 'webkit-playsinline')
        videoEl.setAttribute('playsinline', 'playsinline')
        videoEl.setAttribute('x5-playsinline', 'x5-playsinline')
      }

      videoEl.src = window.URL.createObjectURL(file)
      videoEl.onloadedmetadata = event => {
        clearTimeout(timer)
        videoAnalyzer.duration = videoEl.duration
        videoAnalyzer.width = videoEl.videoWidth
        videoAnalyzer.height = videoEl.videoHeight
        resolve(videoAnalyzer)
      }
      if (onConfirm) {
        timer = setTimeout(() => {
          onConfirm()
        }, 2000)
      }
      if (!externalVideoEl) {
        document.body.appendChild(videoEl)
      }
      videoEl.load()
    })
  },
}

export default videoAnalyzer
